/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {AngularBossPdfComponent as ɵa} from './core/app/modules/angular-boss-pdf/angular-boss-pdf.component';